import { VebinarCard } from './ui/VebinarCard.jsx'

export default VebinarCard
